// https://github.com/intljusticemission/react-big-calendar

import BigCalendar from 'react-big-calendar';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import day from './day';
import defaultView from './default_view';
import events from './events';
import redirect from '../../utils/redirect';

BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));

class Calendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      events: events(this.props.games),
    };
    this.handleSelectEvent = this.handleSelectEvent.bind(this);
  }

  handleSelectEvent(e, target) {
    const id = e.id;
    const url = `/admin/games/${id}/results`;
    redirect(url);
  }

  eventStyleGetter(event) {
    const state = event.state;

    const color = () => {
      switch (state) {
        case 'past':
          return '#767676';

        case 'unprocessed':
          return 'rgba(219, 40, 40, 0.7)';

        case 'current':
          return '#21BA45';

        case 'upcoming':
          return '#2185D0';

        default:
          break;
      }
    };

    const style = {
      backgroundColor: color(),
    };

    return {
      style,
    };
  }

  render() {
    return (
      <div>
        <BigCalendar
          defaultDate={new Date()}
          defaultView="day"
          eventPropGetter={this.eventStyleGetter}
          events={this.state.events}
          onSelectEvent={this.handleSelectEvent}
          step={60}
          views={['day', 'week', 'month']}
          components={{
            day: { event: day },
            week: { event: defaultView },
            month: { event: defaultView },
          }}
        />
      </div>
    );
  }
}

Calendar.propTypes = {
  games: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      start: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default Calendar;
